module.exports = __webpack_public_path__ + "media/font/summernote-f4a47ce9.eot";